var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { class: ["cookies-policy-container"] },
    [
      _c(_setup.LfHeaderTitleComponent, {
        staticClass: "header-title",
        attrs: { title: _setup.title },
      }),
      _c("div", { attrs: { id: "cookies-policy" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }